import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import OtpMobileIcon from "../../assets/Images/OtpMobileIcon 1.png";
import styles from "../../css/OtpModal.module.css";
import "../../css/Login.css";
import CircularProgress from "@mui/material/CircularProgress";
import LoginSubmitWhiteIcon from "../../assets/Icons/RegisterLoginIconOrange.png";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { loginSuccess } from "../store/authSlice";
import { useNavigate } from "react-router-dom";
import CustomAlert from "../../helpers/CustomAlert";
import encryptAES from "../../helpers/encryption";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";

const LoginOtpModal = ({
  handleopenOtp,
  handleCloseOtp,
  username,
  password,
  responseData,
  deviceFingerprint,
  handleOtp,
}) => {
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(60); // 5 minutes = 300 seconds

  useEffect(() => {
    let timer;
    if (handleopenOtp && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [handleopenOtp, timeLeft]);

  // useEffect(() => {
  //   if (timeLeft === 0) {
  //     toast.error("OTP Expired");
  //     handleCloseOtp();
  //   }
  // }, [timeLeft]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };
  const handleInputChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);
    if (value && index < otpValues.length - 1) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedData)) {
      const digits = pastedData.split("");
      setOtpValues(digits);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    } else if (e.key === "ArrowLeft" && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    } else if (e.key === "ArrowRight" && index < otpValues.length - 1) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    const otp = otpValues.join("");
    try {
      const encryptedPassword = encryptAES(password);
      const encryptedUsername = encryptAES(username);
      const encryptedVisitorId = encryptAES(deviceFingerprint);
      const loginData = {
        username: encryptedUsername,
        password: encryptedPassword,
        otp,
        deviceFingerprint: encryptedVisitorId,
      };
      const response = await axiosPostApi(apiList.LOGIN, loginData);
      const respCode = response?.data?.respCode;

      // BY OMKAR
      const courierServiceKey = response?.data?.data?.courierServiceKey;
      // BY OMKAR

      if (response?.data?.status && respCode === "00") {
        dispatch(loginSuccess(response?.data));
        const token = response.data.data.token;
        const name = response.data.data.name;
        const loginTime = new Date().toLocaleString();
        const userRole = response?.data?.data?.userRole;
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("name", name);
        sessionStorage.setItem("username", username);
        sessionStorage.setItem("loginTime", loginTime);
        sessionStorage.setItem("userRole", userRole);

        // BY OMKAR
        sessionStorage.setItem("courierServiceKey", courierServiceKey);
        // BY OMKAR

        toast.success("Login Successfully", { autoClose: 2000 });

        setTimeout(() => {
          setLoading(false);
          navigate("/dashboard");
        }, 500);
      } else if (respCode === "02") {
        setLoading(false);
        CustomAlert({
          title: "Set Password Required",
          text:
            response?.data?.message ||
            "You need to set your password to continue.",
          icon: "warning",
          confirmButtonText: "Set Password",
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate(
                `/auth/set-password?username=${encodeURIComponent(username)}`
              );
            }, 500);
          }
        });
      } else if (respCode === "05") {
        setLoading(false);
        CustomAlert({
          title: "Login Failed",
          text:
            response?.data?.message || "Invalid credentials. Please try again!",
          icon: "error",
          confirmButtonText: "Retry",
        });
      } else {
        setLoading(false);
        CustomAlert({
          title: "Login Failed",
          text:
            response?.data?.message || "Invalid credentials. Please try again!",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "Error occurred while logging in. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  if (!handleopenOtp) return null; // Don't render if modal is not open

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalBox}>
        <div className={styles.modalHeader}>
          <IconButton onClick={handleCloseOtp} size="small" className="z-20">
            <CloseIcon />
          </IconButton>
        </div>

        {/* Background Images */}
        <img
          src={LeftCircle}
          alt="leftImg"
          className="absolute left-0 bottom-0 w-[110px] h-[105px]"
        />
        <img
          src={RightCircle}
          alt="leftImg"
          className="absolute right-0 top-0 w-[110px] h-[105px]"
        />

        <div className={styles.modalContent}>
          <div className={styles.iconWrapper}>
            <img src={OtpMobileIcon} alt="OTP Verification" />
          </div>

          {/* <div className={styles.title}>Verification</div> */}

          <p className={styles.instruction}>
            Please enter the 6 digit code sent to you at
            <br />
            <span>{responseData.mobileNo}</span>
          </p>

          <div className={styles.otpInputContainer}>
            {otpValues.map((value, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                type="text"
                maxLength={1}
                value={value}
                onChange={(e) => handleInputChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={index === 0 ? handlePaste : undefined}
                className={styles.otpInput}
                autoComplete="off"
              />
            ))}
          </div>

          <div className="login-btn-container">
            <div onClick={handleLogin} className="btn loginNow-btn">
              {loading ? (
                <CircularProgress
                  className="circular-loader"
                  style={{ width: "20px", height: "20px" }}
                />
              ) : (
                <span className="login-text">Submit</span>
              )}
            </div>

            <span onClick={handleLogin} className="login-icon">
              <img
                src={LoginSubmitWhiteIcon}
                alt="LoginIcon"
                className="w-[50px]"
              />
            </span>
          </div>

          <div className={styles.resendContainer}>
            {timeLeft > 0 ? (
              <div className={styles.resendText}>
                OTP expire in <strong>{formatTime(timeLeft)}</strong>
              </div>
            ) : (
              // handleCloseOtp()
              <button
                onClick={() => {
                  setOtpValues(["", "", "", "", "", ""]);
                  handleOtp();
                  setTimeLeft(60);
                }}
                disabled={loading}
                className="text-[#ff702b] font-bold "
              >
                Resend OTP
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginOtpModal;
